import http from "../../../service/axios/httpRequest";
import { logout } from "../../../service/localStorage/localStorage";

export const getOnePlansRequest = async (idPlan) => {
     return await http.get("/bff/plan-bff?planId="+idPlan).then(response => response.data)
          .catch(err => {
               if (err.response.status === 401) {
                    logout()
                    window.location.reload()
               }
               throw err;
          });
}

export const getPlansPriceRequest = async (idPlan) => {
     return await http.get("/bff/plan-prices-bff?planId="+idPlan).then(response => response.data)
          .catch(err => {
               if (err.response.status === 401) {
                    logout()
                    window.location.reload()
               }
               throw err;
          });
}

export const EditPlansRequest = async (body) => {
     return await http.put("/bff/plan-bff", body).then(response => response.data)
          .catch(err => {
               if (err.response.status === 401) {
                    logout()
                    window.location.reload()
               }
               alert(err.response.data.message)
               throw err;
          });
}

export const DeletePlansRequest = async (id) => {
     return await http.delete("/bff/plan-bff", { params: { planId: id } }).then(response => response.data)
          .catch(err => {
               if (err.response.status === 401) {
                    logout()
                    window.location.reload()
               }
               alert(err.response.data.message)
               throw err;
          });
}

export const CreatePlanPriceRequest = async (body) => {
     return await http.post("/bff/plan-prices-bff", body).then(response => response.data)
          .catch(err => {
               if (err.response.status === 401) {
                    logout()
                    window.location.reload()
               }

               alert(err.response.data.message)
               throw err;
          });
}


export const EditPriceRequest = async (body, id) => {
     return await http.put("/bff/plan-prices-bff/"+id, body).then(response => response.data)
          .catch(err => {
               if (err.response.status === 401) {
                    logout()
                    window.location.reload()
               }

               alert(err.response.data.message)
               throw err;
          });
}